(function () {
  function log(){ try{ console.log('[TIB relocate]', ...arguments); }catch(e){} }

  // ---------- GATE: nur ausführen, wenn ein Variant-Picker existiert ----------
  function hasVariantPicker() {
    return !!document.querySelector(
      '.product-info__block-item[data-block-type="variant-picker"], .product-info__variant-picker'
    );
  }

  function init() {
    if (!hasVariantPicker()) {
      log('kein Variant-Picker → Skript beendet.');
      return; // <<< keinerlei Listener/Observer werden gesetzt
    }
    log('Variant-Picker gefunden → Skript aktiv.');

    // Ziel: unmittelbar nach dem Variant-Picker (Fallback: nach Preis/Titel)
    function findTarget() {
      return document.querySelector('.product-info__block-item[data-block-type="variant-picker"]')
          || document.querySelector('.product-info__variant-picker')
          || document.querySelector('.product-info__block-item[data-block-type="price"]')
          || document.querySelector('.product-info__block-item[data-block-type="title"]');
    }

    function moveTIB() {
      var tib = document.querySelector('#tee-artwork-form'); // dein TIB-Wurzelknoten
      var target = findTarget();
      if (!tib || !target) return;

      // Schon direkt NACH dem Ziel?
      if (target.nextElementSibling === tib) return;

      try {
        target.insertAdjacentElement('afterend', tib);
        log('Formular verschoben (nach Variant-Picker/Preis/Titel).');
      } catch (e) {
        console.warn('[TIB relocate] Verschieben fehlgeschlagen:', e);
      }
    }

    function reinit() {
      // erst verschieben, dann TIB reinitialisieren
      moveTIB();
      try {
        if (window.TeeinblueApp?.reInit) { window.TeeinblueApp.reInit(); log('TIB reInit() aufgerufen'); }
        else if (window.TeeinblueApp?.init) { window.TeeinblueApp.init(); log('TIB init() aufgerufen'); }
      } catch (e) { /* noop */ }
    }

    // Warten, bis TIB-Form zum ersten Mal da ist (falls später injiziert)
    if (!document.querySelector('#tee-artwork-form')) {
      log('warte auf #tee-artwork-form …');
      var moWait = new MutationObserver(function(muts){
        if (document.querySelector('#tee-artwork-form')) {
          moWait.disconnect();
          reinit();
        }
      });
      moWait.observe(document.documentElement, { childList: true, subtree: true });
    } else {
      reinit();
    }

    // Events nur registrieren, WENN Gate erfüllt war
    ['change','variant:changed','variant-change','theme:variant:change',
     'shopify:section:load','shopify:section:select','shopify:block:select'
    ].forEach(evt => document.addEventListener(evt, reinit));

    // Neu-Rendern des dynamischen Bereichs beobachten (nur lokal)
    ['[data-block-type="payment-terms"]','.buy-buttons','product-form','.product-form'].forEach(sel => {
      var el = document.querySelector(sel);
      if (!el) return;
      new MutationObserver(reinit).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
